import { Route, Routes } from "react-router-dom";

import LoginPage from "./LoginPage";
import TFAPage from "./TFAPage";

export default function AuthPage() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="2fa" element={<TFAPage />} />
      <Route path="logout" element={<>Logout</>} />
      <Route index element={<LoginPage />} />
    </Routes>
  );
}
